const Flickity = require("flickity");
const _ = require("lodash");
const ResponsiveUtility = require("./components.js").ResponsiveUtility;

const defaultOptions = {
  cellSelector: ".slide",
  setGallerySize: true,
  pageDots: false,
  wrapAround: true,
  percentPosition: false,
  adaptiveHeight: true,
};

class Gallery {
  createGallery(options) {
    if (this.flickity) {
      this.flickity.destroy();
    }
    this.flickity = new Flickity(
      this.el[0],
      _.assign(this.finalOptions, options)
    );
  }

  constructor(element, options) {
    this.el = $(element);

    const self = this;

    this.finalOptions = _.assign(
      defaultOptions,
      {
        autoPlay: true,
        prevNextButtons: $(element).find("img").length > 1 ? true : false,
      },
      options
    );

    new ResponsiveUtility({
      phone: function () {
        self.createGallery({
          setGallerySize: true,
        });
      },
      tablet: function () {
        self.createGallery({
          setGallerySize: true,
        });
      },
      desktop: function () {
        self.createGallery({
          setGallerySize: false,
        });
      },
      huge: function () {
        self.createGallery({
          setGallerySize: false,
        });
      },
    });
  }
}

class TextGallery {
  constructor(element, options) {
    const self = this;
    const finalOptions = _.assign(
      defaultOptions,
      {
        autoPlay: false,
        prevNextButtons: true,
      },
      options
    );

    new ResponsiveUtility({
      phone: function () {
        self.flickity = new Flickity(
          element,
          _.assign(finalOptions, {
            setGallerySize: true,
          })
        );
      },
      tablet: function () {
        self.flickity = new Flickity(
          element,
          _.assign(finalOptions, {
            setGallerySize: true,
          })
        );
      },
      desktop: function () {
        self.flickity = new Flickity(
          element,
          _.assign(finalOptions, {
            setGallerySize: false,
          })
        );
      },
      huge: function () {
        self.flickity = new Flickity(
          element,
          _.assign(finalOptions, {
            setGallerySize: false,
          })
        );
      },
    });
  }
}

class InlineGallery {
  createGallery() {
    if (this.flickity) {
      this.flickity.destroy();
    }
    this.flickity = new Flickity(this.el[0], this.finalOptions);
  }
  createTablet() {
    let breakpointOptions = {
      groupCells: 1,
      wrapAround: true,
      cellAlign: "center",
      prevNextButtons: true,
      autoPlay: true,
      on: {
        ready: function () {
          const $el = $(this.element);
          $el.addClass("fade-gallery");
        },
      },
    };
    this.finalOptions = _.assign(defaultOptions, breakpointOptions);
    this.createGallery();
  }

  createDesktop() {
    let breakpointOptions = {
      groupCells: 3,
      wrapAround: this.size > 3 ? true : false,
      cellAlign: "left",
      prevNextButtons: false,
      autoPlay: false,
    };
    this.finalOptions = _.assign(defaultOptions, breakpointOptions);
    this.createGallery();
  }

  constructor(_element, _options) {
    this.el = $(_element);
    this.size = this.el.find("img").length;
    const self = this;

    new ResponsiveUtility({
      phone: function () {
        self.createTablet();
      },
      tablet: function () {
        self.createTablet();
      },
      desktop: function () {
        self.createDesktop();
      },
      huge: function () {
        self.createDesktop();
      },
    });
  }
}

class AwardsSlider {
  replaceArrows(flick) {
    const $prev = this.el.find(".flickity-prev-next-button.previous");
    const $next = this.el.find(".flickity-prev-next-button.next");
    $prev.find("svg").remove();
    $next.find("svg").remove();
    $prev.append('<img src="/images/arrow-left.svg"/>');
    $next.append('<img src="/images/arrow-right.svg"/>');
  }

  alignText(flick) {
    function calc() {
      let max_text = 0,
        max_image = 0;
      flick.$element.find(".item .thumbnail").css("min-height", "0");
      flick.$element.find(".item span").css("min-height", "0");
      flick.$element.find(".item").each(function () {
        const $el = $(this);
        const ih = $el.find(".thumbnail").innerHeight();
        const th = $el.find("span").innerHeight();
        max_image = ih > max_image ? ih : max_image;
        max_text = th > max_text ? th : max_text;
      });
      flick.$element.find(".item .thumbnail").css("min-height", max_image);
      flick.$element.find(".item span").css("min-height", max_text);
      flick.resize();
    }
    $(window).resize(
      _.debounce(function () {
        calc();
      }, 300)
    );
    calc();
  }

  createGallery(options) {
    this.finalOptions = _.assign(this.initOptions, options);
    if (this.flickity) {
      this.flickity.destroy();
    }
    this.flickity = new Flickity(this.el[0], this.finalOptions);
  }

  constructor(element, options) {
    const self = this;
    this.el = $(element);

    this.initOptions = _.assign(defaultOptions, options, {
      prevNextButtons: true,
      cellAlign: "left",
      setGallerySize: true,
      autoPlay: false,
      cellSelector: ".item",
      on: {
        ready: function () {
          const flick = this;
          self.replaceArrows(flick);
          self.alignText(flick);
        },
      },
    });

    new ResponsiveUtility({
      phone: function () {
        self.createGallery({
          groupCells: 1,
          wrapAround: this.size > 1 ? true : false,
        });
      },
      tablet: function () {
        self.createGallery({
          groupCells: 2,
          wrapAround: this.size > 2 ? true : false,
        });
      },
      desktop: function () {
        self.createGallery({
          groupCells: 3,
          wrapAround: this.size > 3 ? true : false,
        });
      },
      huge: function () {
        self.createGallery({
          groupCells: 3,
          wrapAround: this.size > 3 ? true : false,
        });
      },
    });
  }
}

module.exports = {
  Gallery,
  AwardsSlider,
  InlineGallery,
  TextGallery,
};
